import { Link } from 'react-router-dom';
import { useCookieConsent } from '../context/CookieConsentContext';
import { WhatsAppIcon } from './IconSet';
import { ADMIN_FEATURE_FLAGS } from '../config/adminFeatureFlags';

const footerLinks = {
  company: [
    { label: 'About Us', to: '/about' },
    { label: 'How It Works', to: '/about#how-it-works' },
    { label: 'Careers', to: '/careers' },
    { label: 'Contact Us', to: '/contact' },
  ],
  resources: [
    { label: 'Browse Properties', to: '/browse' },
    { label: 'List a Property', to: '/list-property' },
    { label: 'Become a Partner', to: '/become-an-agent' },
    { label: 'Property Guide', to: '/blog' },
    { label: 'Safety Tips', to: '/safety' },
    { label: 'Help Centre', to: '/help' },
  ],
  locations: [
    { label: 'Lagos Properties', to: '/lagos/apartments' },
    { label: 'Abuja Properties', to: '/fct/apartments' },
    { label: 'Port Harcourt', to: '/rivers/apartments' },
    { label: 'Ibadan Properties', to: '/oyo/apartments' },
  ],
  legal: [
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Disclaimer', to: '/terms#disclaimer' },
    { label: 'Cookie Policy', to: '/cookie-policy' },
    { label: 'Listing Policy', to: '/listing-policy' },
    // Gated with agent verification itself (ADMIN_FEATURE_FLAGS.agentRequests)
    // so re-enabling that one flag brings this link back too - see
    // client/src/config/adminFeatureFlags.js.
    ...(ADMIN_FEATURE_FLAGS.agentRequests
      ? [{ label: 'Agent Verification Policy', to: '/agent-verification-policy' }]
      : []),
  ],
};

function SiteFooter() {
  const currentYear = new Date().getFullYear();
  const { openSettings } = useCookieConsent();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <strong className="site-footer__logo">NaijaNest</strong>
          <p className="site-footer__tagline">
            Nigeria's home for rentals and short-lets, with sales also available.
          </p>
          <div className="site-footer__social">
            <a
              href="https://wa.me/2349043933993"
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
            >
              <WhatsAppIcon size={20} />
            </a>
            <a
              href="https://instagram.com/naijanest_prime_hub"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="site-footer__links-group">
          <h4>Company</h4>
          <ul>
            {footerLinks.company.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__links-group">
          <h4>Resources</h4>
          <ul>
            {footerLinks.resources.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__links-group">
          <h4>Legal</h4>
          <ul>
            {footerLinks.legal.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
            <li>
              <button type="button" className="site-footer__link-button" onClick={openSettings}>
                Cookie Settings
              </button>
            </li>
          </ul>
        </div>

        <div className="site-footer__links-group">
          <h4>Popular Locations</h4>
          <ul>
            {footerLinks.locations.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="site-footer__copyright">
          <p>&copy; {currentYear} NaijaNest. All rights reserved.</p>
          <p className="site-footer__legal-entity">
            NaijaNest is operated by NaijaNest Prime Hub, a company registered in Nigeria (RC
            9619830).
          </p>
        </div>
        <p>Made with &#10084;&#65039; in Nigeria</p>
      </div>
    </footer>
  );
}

export default SiteFooter;
